// Small preferences card so any member can opt in/out of the weekly digest.
// Backend defaults email_digest_optin to true for new signups; toggling
// updates /api/auth/me with the boolean.

import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function EmailPreferencesCard() {
  const { user, refreshMe } = useAuth();
  const [busy, setBusy] = useState(false);
  const optedIn = user?.email_digest_optin !== false;

  const toggle = async () => {
    setBusy(true);
    try {
      await api.patch("/auth/me", { email_digest_optin: !optedIn });
      if (typeof refreshMe === "function") await refreshMe();
      toast.success(optedIn ? "You're unsubscribed from the weekly digest" : "You're subscribed to the weekly digest");
    } catch {
      toast.error("Could not update preference");
    } finally { setBusy(false); }
  };

  return (
    <section className="jj-card p-6 mt-8" data-testid="email-preferences-card">
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="overline text-burgundy">Email preferences</div>
          <h3 className="font-serif text-2xl text-jjblue mt-1 leading-tight">Weekly prayer circles digest</h3>
          <p className="text-sm text-[var(--jj-muted)] mt-2 max-w-lg">
            A quiet Sunday-morning email highlighting new prayer circles born in the community this week. Never more than one per week.
          </p>
        </div>
        <Mail className="h-6 w-6 text-burgundy/60 shrink-0" strokeWidth={1.4} />
      </div>
      <div className="mt-4 flex items-center gap-3">
        <button
          onClick={toggle}
          disabled={busy}
          className={optedIn ? "btn-secondary !py-2 !px-4 text-sm" : "btn-primary !py-2 !px-4 text-sm"}
          data-testid="email-digest-toggle"
        >
          {busy ? "Saving…" : optedIn ? "Unsubscribe" : "Subscribe"}
        </button>
        <span className="text-xs text-[var(--jj-muted)]" data-testid="email-digest-status">
          {optedIn ? "You'll receive the weekly digest." : "You're unsubscribed."}
        </span>
      </div>
    </section>
  );
}
